export const PAGE_LOADER = "PAGE_LOADER";
export const ACCORDIAN_INDEX = "ACCORDIAN_INDEX";

